import t,{useContext as e}from"react";const o=t.createContext({name:"default"}),r=()=>e(o);export{o as RadioGroupContext,r as useRadioGroupContext};
